import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const features = [
  {
    icon: 'bi-lightning-charge-fill',
    title: 'Atualização em tempo real',
    description:
      'Quem está com você no mercado vê as marcações na hora, sem recarregar a página.',
  },
  {
    icon: 'bi-diagram-3-fill',
    title: 'Categorias por setor',
    description:
      'Separe hortifruti, limpeza e bebidas — e alterne entre contagem por unidade ou por peso.',
  },
  {
    icon: 'bi-cash-coin',
    title: 'Total sempre à vista',
    description:
      'A barra de resumo acompanha a rolagem mostrando progresso e valor acumulado da compra.',
  },
];

const steps = [
  'Crie uma lista com um nome simples, como "mercado do mês".',
  'Adicione itens soltos ou agrupe por categoria.',
  'No mercado, marque o que já foi para o carrinho e acompanhe o total.',
];

const LandingPage = () => {
  const { authData, isAuthenticated } = useAuth();
  const firstName = authData.userName?.trim()
    ? authData.userName.trim().split(' ')[0]
    : 'você';

  return (
    <div className="page">
      <section className="hero-grid">
        <div className="surface-card card-pad hero-main">
          <div>
            <span className="eyebrow">
              {isAuthenticated ? `Bem-vindo de volta, ${firstName}` : 'Planejamento de compras'}
            </span>
            <h1 className="page-title">
              Suas compras organizadas do planejamento até o caixa.
            </h1>
            <p className="section-copy">
              Monte listas, acompanhe quanto já foi gasto, divida por setor do mercado e
              compartilhe com quem compra junto — no computador ou no celular.
            </p>
          </div>

          <div className="btn-row">
            {isAuthenticated ? (
              <>
                <Link to="/listas" className="btn btn--primary">
                  <i className="bi bi-list-check" aria-hidden="true"></i>
                  Abrir minhas listas
                </Link>
                <Link to="/perfil" className="btn btn--ghost">
                  Ver meu perfil
                </Link>
              </>
            ) : (
              <>
                <Link to="/register" className="btn btn--primary">
                  Criar conta grátis
                </Link>
                <Link to="/login" className="btn btn--ghost">
                  Já tenho conta
                </Link>
              </>
            )}
          </div>

          <div className="metric-grid">
            <div className="metric">
              <span className="metric__label">Uso</span>
              <strong className="metric__value">Celular e desktop</strong>
            </div>
            <div className="metric">
              <span className="metric__label">Tema</span>
              <strong className="metric__value">Claro e escuro</strong>
            </div>
            <div className="metric">
              <span className="metric__label">Compra</span>
              <strong className="metric__value">Colaborativa</strong>
            </div>
          </div>
        </div>

        <div className="hero-aside">
          <div className="preview-card preview-card--brand">
            <span className="preview-card__title">Resumo de uma compra</span>
            <div className="preview-card__row">
              <span>Itens comprados</span>
              <strong>12 / 18</strong>
            </div>
            <div className="preview-card__row">
              <span>Valor acumulado</span>
              <strong>R$ 186,40</strong>
            </div>
            <div className="preview-card__row">
              <span>Categorias</span>
              <strong>Feira, mercado, limpeza</strong>
            </div>
          </div>

          <div className="preview-card">
            <span className="preview-card__title">Feito para usar no corredor</span>
            <p>
              Campos grandes o bastante para marcar com o polegar, teclado numérico ao
              digitar preço e vírgula aceita do jeito que a gente escreve.
            </p>
          </div>
        </div>
      </section>

      <section className="card-grid" aria-label="Recursos">
        {features.map((feature) => (
          <article className="surface-card card-pad feature-card" key={feature.title}>
            <span className="feature-card__icon" aria-hidden="true">
              <i className={`bi ${feature.icon}`}></i>
            </span>
            <h2 className="section-subtitle">{feature.title}</h2>
            <p>{feature.description}</p>
          </article>
        ))}
      </section>

      <section className="surface-card card-pad">
        <div className="section-heading">
          <div className="section-heading__text">
            <span className="eyebrow">Como funciona</span>
            <h2 className="section-subtitle">Três passos e a compra está organizada</h2>
          </div>
        </div>

        <div className="workflow-grid">
          {steps.map((step, index) => (
            <div className="workflow-step" key={step}>
              <span className="workflow-step__number" aria-hidden="true">
                {index + 1}
              </span>
              <p>{step}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
